export const sortableFields = [
  "plano_plateau",
  "nbr_jr_demo",
  "div_nom",
  "plans_seq",
  "mod_descr",
  "prod_num",
  "four_nom",
  "act_cd",
  "prod_collection",
  "planost_ventes",
  "planost_ventes_mcx",
  "ventes_jr"
];